import { useState } from 'react'

// timer helper for users to continuously run actions
// cancel any actions that are awaiting if user runs any new action
// then run the setTimeout function when users stop interacting
export const useTimer = (timeoutInMs: number = 2000) => {
  const [timerId, setTimerId] = useState<ReturnType<typeof setTimeout>>()

  const setTimer = (someFunction: () => void) => {
    if (timerId) {
      clearTimeout(timerId)
    }
    const timerLength = timeoutInMs
    const timer = () => setTimeout(() => someFunction(), timerLength)
    const newTimerId = timer()
    setTimerId(newTimerId)
  }

  return { setTimer }
}
